import { gsap } from "gsap";

class VisualSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.container = this.dom.el.querySelector('[data-js="slide-container"]');
    this.dom.copy = document.querySelector('[data-js="visual-copy"]');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);

    this.playing = false;
    this.gap = 25;

    // this.unit = (this.setBreakpoint()) ? 'vw' : 'px';
    this.unit = 'vw';
    this.windowW = null;
    this.scaling = null;
    this.slideW = null;

    this.animateAry = [];

    // SPのy座標はcssで一括調整
    this.state = [];

    this.init();
  }

  init() {
    const _this = this;
    this.setHtml();
  }

  setHtml() {
    const _this = this;
    function resolveSetHtml() {
      return new Promise((resolve) => {
        for(let i = 1; i <= 5; ++i) {
          const index = (i + 5 < 10) ? '0' + (i + 5) : i + 5;
          const html = `<li class="hm-visual-slide__list" data-js="slide-list" data-index="${index}">
              <figure class="hm-visual-slide__image">
                <span class="c-clip"><img src="./assets/img/home/slide-0${i}.jpg" width="275" height="490" alt=""></span>
              </figure>
            </li>`;
          _this.dom.container.insertAdjacentHTML('beforeend', html);
          if (i === 5) resolve();
        }
      });
    }
    
    // 変数に代入された非同期関数式
    const startAnimation = async function () {
      await resolveSetHtml(true);
      return true;
    };
    
    startAnimation().then((v) => {
      // resolveSetHtmlの処理が終わったら実行
      // ブレイクポイントの瞬間に発火
      this.mql.addListener(this.checkBreakPoint);
      // 初回チェック
      this.checkBreakPoint(this.mql);
    });
  }

  setState() {
    // this.adjY = (innerHeight - 720) * .5;
    this.adjY = 0;
    this.playing = true;
    this.windowW = (this.setBreakpoint()) ? 1440 : 375;
    this.scaling = (this.setBreakpoint()) ? 1 : .75;
    this.slideW = (this.setBreakpoint()) ? ((275 + this.gap) / this.windowW) * 100 : ((206 + this.gap) / this.windowW) * 100;
    this.state = [
      { rotate: `${-41 * 1}`, y: `${(((1530 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, },
      { rotate: `${-38 * 1}`, y: `${(((1276 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, },
      { rotate: `${-35 * 1}`, y: `${(((1050 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, },
      { rotate: `${-32 * 1}`, y: `${(((850 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, },
      { rotate: `${-29 * 1}`, y: `${(((670 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, },
      { rotate: `${-26 * 1}`, y: `${(((510 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: .25, },
      { rotate: `${-23 * 1}`, y: `${(((370 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: .6, },
      { rotate: `${-20 * 1}`, y: `${((((252 - 20) - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 1, },
      { rotate: `${-17 * 1}`, y: `${(((152 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: .6, },
      { rotate: `${-14 * 1}`, y: `${(((68 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: .25, },
      { rotate: `${-11 * 1}`, y: `${(((0 - this.adjY) * this.scaling) / this.windowW) * 100}vw`, opacity: 0, }
    ]
  }

  setBreakpoint() {
    return (window.innerWidth >= 768)
  }

  setPosition() {
    const _this = this;
    
    function resolveAfterArraySetting() {
      return new Promise((resolve) => {
        // this.dom.slidesの最初の要素取得
        const shifted = _this.dom.slides[0];
        // 取得した要素を最後に移動
        _this.dom.container.append(shifted);
        // スライド一覧取得
        _this.dom.slides = _this.dom.el.querySelectorAll('[data-js="slide-list"]');
        resolve();
      });
    }

    // 変数に代入された非同期関数式
    const setProp = async function () {
      await resolveAfterArraySetting(true);
      return true;
    };
    
    setProp().then(() => {
      this.anim();
      this.dom.copy.dataset.is = 'show'
    });
  }

  anim() {
    const _this = this;
    function resolveAfterAnimation() {
      return new Promise((resolve) => {
        [..._this.dom.slides].forEach((el, i) => {
          _this.animateAry.push(
            gsap.fromTo(el,{
              rotate: _this.state[i + 1].rotate,
              x: `${_this.slideW * (i + 1)}${_this.unit}`,
              y: _this.state[i + 1].y,    
              opacity: _this.state[i + 1].opacity,    
            }, {
              rotate: _this.state[i + 0].rotate,
              x: `${_this.slideW * (i + 0)}${_this.unit}`,
              y: _this.state[i + 0].y,
              opacity: _this.state[i + 0].opacity,
              delay: 3,
              ease: 'easeInOut',
              onComplete: () => {
                if (i === 9) {
                  resolve();
                }
              }
            })
          )
        })
      });
    }
    
    // 変数に代入された非同期関数式
    const startAnimation = async function () {
      await resolveAfterAnimation(true);
      return true;
    };
    
    startAnimation().then((v) => {
      // resolveAfterAnimationのアニメーションが終わったら再度setPosition()を実行
      this.setPosition();
      this.animateAry = [];
    });
  }

  play() {
    const _this = this;
    this.setState();

    function resolveAfterAnimation() {
      return new Promise((resolve) => {
        [..._this.dom.slides].forEach((el, i) => {
          gsap.fromTo(el,{
            x: `${(_this.slideW * ((_this.setBreakpoint()) ? 5.5 : 7)) + 100}${_this.unit}`,
            y: 0
          }, {
            rotate: _this.state[i + 0].rotate,
            x: `${_this.slideW * (i + 0)}${_this.unit}`,
            y: _this.state[i + 0].y,
            opacity: _this.state[i + 0].opacity,
            delay: .9,
            duration: .6,
            ease: 'easeInOut',
            onComplete: () => {
              resolve();              
            }
          })
        })
      });
    }
    
    // 変数に代入された非同期関数式
    const startAnimation = async function () {
      await resolveAfterAnimation(true);
      return true;
    };
    
    startAnimation().then((v) => {
      // resolveAfterAnimationのアニメーションが終わったら再度setPosition()を実行
      this.setPosition();
    });
  }

  destory() {
    [...this.animateAry].forEach(anim => {
      anim.kill();
    })
  }
  
  checkBreakPoint(_mql) {
    if (!_mql.matches) {
      // console.log('sp');
      if (this.playing) this.destory();
      this.dom.slides = this.dom.el.querySelectorAll('[data-js="slide-list"]');
      setTimeout(() => {
        this.play();
      },.3)
      return;
    } else {
      // console.log('pc');
      if (this.playing) this.destory();
      this.dom.slides = this.dom.el.querySelectorAll('[data-js="slide-list"]');   
      setTimeout(() => {
        this.play();
      },.3)
      return;
		}
	}
}

export default VisualSlides